import React from 'react';
import { cn } from '../utils/cn';

type ButtonProps = {
  children: React.ReactNode;
  onClick?: () => void;
  variant?: 'primary' | 'secondary' | 'outline' | 'ghost';
  className?: string;
  type?: 'button' | 'submit';
  disabled?: boolean;
};

export default function Button({ 
  children, 
  onClick, 
  variant = 'primary', 
  className,
  type = 'button',
  disabled = false
}: ButtonProps) {
  const baseStyles = 'px-6 py-3 rounded-lg font-medium transition-colors duration-200 inline-flex items-center justify-center gap-2';
  
  const variants = {
    primary: 'bg-[#236caf] hover:bg-[#004060] text-white',
    secondary: 'bg-[#318231] hover:bg-[#236c23] text-white',
    outline: 'border-2 border-[#236caf] text-[#236caf] hover:bg-[#236caf] hover:text-white',
    ghost: 'text-[#236caf] hover:bg-blue-50'
  };

  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled}
      className={cn(
        baseStyles, 
        variants[variant], 
        disabled && 'opacity-50 cursor-not-allowed',
        className
      )}
    >
      {children}
    </button>
  );
}

export { Button }